<template>
  <div class="container">
    <div class="title">收藏宝贝</div>
    <div class="content" v-if="CollectUserList.length > 0">
      <div
        class="item"
        v-for="(item, index) of CollectUserList"
        :key="item.pid"
      >
        <div class="order">{{ index + 1 + (page - 1) * limit }}</div>
        <div class="left" @click="goToProduct(item.pid)">
          <img :src="item.image" alt="" />
        </div>
        <div class="right">
          <div class="name">{{ item.store_name }}</div>
          <div class="price">￥{{ item.price }}</div>
        </div>
        <div class="btn" @click="delCollect(item.pid)">删除</div>
      </div>
    </div>
    <div v-else class="none">
      <img src="@assets/pc/images/home/love.png" alt="" />
      您还没有收藏的宝贝，快去收藏吧！
    </div>
    <div class="page" v-if="CollectUserList.length > 0">
      <Page :total="pageSum" @on-change="change" :page-size="limit"></Page>
    </div>
  </div>
</template>

<script>
import { getCollectUser, getCollectDel } from "@api/user";
export default {
  name: "GoodsCollection",
  data() {
    return {
      CollectUserList: [],
      page: 1,
      limit: 5,
      pageSum: 0
    };
  },
  created() {
    this.getCollectUserList();
  },
  methods: {
    getCollectUserList() {
      getCollectUser(this.page, this.limit).then(res => {
        this.CollectUserList = res.data;
        this.pageSum = parseInt(res.msg);
      });
    },
    change(index) {
      this.page = index;
      this.getCollectUserList();
    },
    delCollect(id) {
      getCollectDel(id, "product").then(() => {
        this.$Message.success("删除成功");
        this.getCollectUserList();
      });
    },
    goToProduct(id) {
      this.$router.push({
        path: "/detail/" + id
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  .title
    font-size 16px
    border-bottom 1px dashed #ccc
    padding-bottom 5px
    padding-left 5px
  .content
    margin-top 10px
    .item
      display flex
      padding 10px
      border-bottom 1px solid #ccc
      .order
        line-height 100px
        text-align center
        font-size 16px
        width 100px
      .left
        width 100px
        height 100px
        cursor pointer
        img
          width 100%
          height 100%
      .right
        margin-left 20px
        width 360px
        font-size 16px
        .name
          color #333
          margin-bottom 30px
        .price
          color #fc4141
      .btn
        cursor pointer
        text-align center
        width 60px
        height 30px
        line-height 30px
        border 1px solid #bbb
        border-radius 5px
        color #282828
        margin-top 35px
  .page
    display flex
    flex-direction row-reverse
    margin-top 10px
  .none
    display flex
    flex-direction column
    height 200px
    justify-content center
    align-items center
    font-size 16px
    color #666
    margin-top 30px
    img
      width 200px
      height 120px
      margin-bottom 10px
</style>
